/* eslint-disable @next/next/no-img-element */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useRouter } from "next/navigation";

import { FeaturedBrand } from "@/types/General";

interface HomeCrossCultureProps {
  items: FeaturedBrand[];
}
function HomeCrossCulture({ items = [] }: HomeCrossCultureProps) {
  const router = useRouter();
  type SliderType = any;
  const sliderRef = useRef<SliderType | null>(null);

  const settings2 = {
    infinite: items.length > 8,
    slidesToShow: 8,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: items.length > 5,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: items.length > 4,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: items.length > 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: items.length > 2,
        },
      },
    ],
  };

  return (
    <>
      <section className="home_collection_sc">
        <div className="container">
          <div className="s_head hd_4">
            <h2 className="fw_med">Regional Fashion</h2>
            <p>
              Redefining modern fashion through Korean and American influence
            </p>
          </div>

          <Slider ref={sliderRef} {...settings2} className="brand_slider">
            {items.map((item) => (
              <div
                key={item.id}
                className="brand_sssitem"
                onClick={() => {
                  const hasAllKeys = item?.banner_links?.every(
                    (link) => link?.linkable_id && link?.linkable_type && link?.type
                  );

                  if (hasAllKeys) {
                    if (item?.type === "brand") {
                      router.push(
                        `/product/product-category?brandIds=${item?.banner_links
                          ?.map((link) => link?.linkable_id)
                          .join(",")}`
                      );
                    } else if (item.type === "category") {
                      router.push(
                        `/product/product-category?categoryIds=${item?.banner_links
                          ?.map((link) => link?.linkable_id)
                          .join(",")}`
                      );
                   
                    } else if (item.type === "product") {
                      router.push(
                        `/product/product-category?productIds=${item?.banner_links
                          ?.map((link) => link?.linkable_id)
                          .join(",")}`
                      );
                    } else {
                      router.push("/product/product-category?type=recommended");
                    }
                  } else {
                    router.push("/product/product-category?type=recommended");
                  }
                }}
                style={{ cursor: 'pointer' }}
              >
                <div className="brand_info">
                  <figure className="brand_bg">
                    <img
                      src={item.image}
                      alt={item.title || "banner"}
                    />
                  </figure>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>
    </>
  );
}

export default HomeCrossCulture;
